<template>
  <section class="vbox">
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>店铺</el-breadcrumb-item>
          <el-breadcrumb-item>商品分类</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-main">
        <el-form :inline="true" size="medium">
          <el-form-item>
            <el-button type="primary" class="el-icon-circle-plus-outline" v-on:click="Add" >新增</el-button>
          </el-form-item>         
          <el-form-item >
            <el-input  placeholder="类别名称" v-model="queryParam.name" size="small" clearable></el-input>
          </el-form-item>       
          <el-form-item >
            <el-input  placeholder="商家名称" v-model="queryParam.businessName" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="Search" >查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="categorys" style="width: 100%">
          <el-table-column  prop="Name" fixed="left" label="名称"> </el-table-column>
          <el-table-column  prop="BusinessName" :show-overflow-tooltip="true" label="所属商家"> </el-table-column>
          <el-table-column  prop="IndustryName"  label="行业"> </el-table-column>
          <el-table-column  prop="Sort"  label="排序"> </el-table-column>
          <el-table-column  prop="Unit"  label="单位"> </el-table-column>
          <el-table-column  prop="Memo"  label="备注" ></el-table-column>
          <el-table-column  fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click.native.prevent="Edit(scope.row.Id)" type="text" size="small">编辑</el-button>
              <el-button @click.native.prevent="DeleteRow(scope.row.Id)" type="text" size="small">&nbsp; 删除 </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :hide-on-single-page="true"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParam.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryParam.totalCount">
        </el-pagination>
      </div> 
    </section>  
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {        
        categorys:[],
        queryParam:{
          name:'',
          businessName:'',
          pageIndex:1,
          pagesize:10,
          totalCount:10,
          sort:' id desc ',
        }
      }
    },
    computed:{
    },
    mounted(){
      if (this.$route.params.queryParam) {
        this.queryParam = this.$route.params.queryParam
      }
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.queryParam.pageIndex = 1;
        this.GetData();
      },
      Add:function(){
        this.$router.push({
          name:'productCategoryInfo',
          params:{
            Id:''
          }
        })
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/ProductCategory/Index',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.categorys = resp.data.categorys
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      Edit(id){
        this.$router.push({
          name:'productCategoryInfo',
          params:{
            Id:id,
            queryParam: this.queryParam
          }
        })
      },
      DeleteRow(id) {
        this.$confirm('确定要删除该类别吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/ProductCategory/Delete',
            data:{
              id: id
            }
          }).then(function (resp) {  
            if(resp.data.errorCode==0){              
              that.$message.success(resp.data.message);
              that.GetData();
            }else {              
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val 
        this.GetData()

      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>